import { render, staticRenderFns } from "./DownloadContactForm.vue?vue&type=template&id=0fc89cf0&scoped=true&"
import script from "./DownloadContactForm.vue?vue&type=script&lang=js&"
export * from "./DownloadContactForm.vue?vue&type=script&lang=js&"
import style0 from "./DownloadContactForm.vue?vue&type=style&index=0&id=0fc89cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc89cf0",
  null
  
)

export default component.exports